import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { AssessmentSubmission } = await import('./index');
    return {
        Component: AssessmentSubmission,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
